// extracted by mini-css-extract-plugin
export default {"button":"Nb4JS","keywords":"QZ5OF"};